var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.left ? 'nav_bar' : 'nav_bar nav_border'},[_c('van-nav-bar',{attrs:{"title":"反馈","left-arrow":"","fixed":"","placeholder":"","safe-area-inset-top":""}},[_c('img',{attrs:{"slot":"left","src":_vm.getImgUrl()},on:{"click":_vm.onClickLeft},slot:"left"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }